import {LoggerService} from "./core/logger/LoggerService";

require('./../resources/scss/main-desktop.scss');

import * as React from "react";
import * as ReactDOM from "react-dom";
import {ApplicationRouter} from "./routes/ApplicationRouter";
import {Provider} from 'react-redux';
import {createStore} from 'redux';
import {AppReducer, AppRootReducer} from "./store";
//import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import {MuiThemeProvider} from "@material-ui/core/styles";
import {createMuiTheme} from '@material-ui/core/styles';
import pink from '@material-ui/core/colors/pink';
import {actionLogChanged} from "./core/store";
import {composeWithDevTools} from "redux-devtools-extension";
import {t} from './core/localization';
import ReduxToastr from "react-redux-toastr";
import {AppConfig} from "./config";
import {LocaleStorage} from "./core/LocaleStorage";
import {GlobalActionTypes} from "./store/global";
t.setLanguage(AppConfig().language)

//ffde00 - zuta
// 0f3c68 - plava
//

const theme = createMuiTheme({
	palette: {
		primary: {
			// main: '#ed1a3a' telekom red
			main: '#0b6cb9'
		},
		secondary: {main: '#afd04c'}
	},
	typography: {
		// useNextVariants: true,
	},
});

// init store
export const AppStore = createStore(AppReducer, LocaleStorage.loadState())
// export const AppStore = createStore(AppRootReducer)

AppStore.subscribe(() => {
	const state = AppStore.getState()
	LocaleStorage.saveState(state)
})

let test = LocaleStorage.loadState()

//init logger
LoggerService.onLogChanged = actionLogChanged

// end loading if saved in state
AppStore.dispatch({type: GlobalActionTypes.END_LOADING})

ReactDOM.render(<Provider store={AppStore}>
							<MuiThemeProvider theme={theme}>
								<ApplicationRouter/>
								<ReduxToastr
									timeOut={4000}
									newestOnTop={false}
									preventDuplicates
									position="top-right"
									transitionIn="fadeIn"
									transitionOut="fadeOut"
									progressBar
									closeOnToastrClick/>
							</MuiThemeProvider>
						</Provider>,document.getElementById('app-container'));
